import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_auth/customer/locations/$locationId/electrical/',
)({
    component: RouteComponent,
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/customer/locations/$locationId/electrical/projects', params });
    },
});

function RouteComponent() {
    return null;
}
